import PropTypes from 'prop-types';
import React from 'react'
import createReactClass from 'create-react-class';
import TimerMixin from 'react-timer-mixin';
import { scroller, Element } from 'react-scroll'
import { reduce } from 'underscore'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getNewMainFeed, getNewCampFeed, emptyNewPosts } from '~/actions/feed'

import Submit from '../DashboardParts/DashboardPart-Submit'

import Question from './ContentParts/ContentPart-Question'
import Article from './ContentParts/ContentPart-Article'
import Statement from './ContentParts/ContentPart-Statement'

import FeedLoader from './ContentParts/ContentPart-Loading'

const Feed = createReactClass({

	propTypes: {
		camp: PropTypes.object,
		campSlug: PropTypes.string,
	},

	mixins: [TimerMixin],

	getInitialState: function() {
		return {
			posts: this.props.feed.posts,
			selectedPostID: '',
			forceRefresh: false
		}
	},

	componentDidMount: function() {

		this.setInterval(
			() => {

				if( !!this.props.camp ) {

					let posts = this.props.feed.posts;

					this.props.getNewCampFeed(
						this.props.campSlug, 
						posts.length > 0 ? posts[0].ID : 0
					)

				} else {

					let posts = this.state.posts.length > 0 ? this.state.posts : this.props.feed.posts;

					this.props.getNewMainFeed( posts.length > 0 ? posts[0].ID : false )

				}
			},
			20000
		)

	},

	componentDidUpdate: function(prevProps, prevState) {

		var prevCurrLength = prevProps.feed.posts.length,
			newCurrLength = this.props.feed.posts.length;

		if( !prevProps.feed.posts.length && !!this.props.feed.posts.length && !!window.location.hash ) {
			scroller.scrollTo(window.location.hash.substring(1), {
				smooth: true
			});
		}

		let toUpdate = prevCurrLength !== newCurrLength;

		if( !toUpdate ) {
			let prevRepliesLength = reduce(prevState.posts, (memo, post)=>{ return memo + (post.post_type.singular_lower === 'statement' ? post.reply_count : 0); }, 0),
				newRepliesLength = reduce(this.props.feed.posts, (memo, post)=>{ return memo + (post.post_type.singular_lower === 'statement' ? post.reply_count : 0); }, 0);
			toUpdate = prevRepliesLength !== newRepliesLength;
		}

		if( !toUpdate ) return;

		this.setState({
			posts: this.props.feed.posts
		})

	},

	addNewPosts: function() {
		let oldPosts = this.state.posts.length > 0 ? this.state.posts : this.props.feed.posts,
			newPosts = this.props.feed.newPosts,
			shouldUpdate = !oldPosts.length || newPosts[ newPosts.length - 1 ].ID > oldPosts[0].ID;
		this.setState({
			posts: shouldUpdate ? newPosts.concat(oldPosts) : oldPosts
		})
		this.props.emptyNewPosts()
	},

	selectPost: function(ID) {
		this.setState({
			selectedPostID: ID
		})
	},

	render: function() {

		let posts = this.state.posts.length > 0 && !this.state.forceRefresh ? this.state.posts : this.props.feed.posts,
			isCamp = !!this.props.camp,
			hasCampAccess = isCamp && (this.props.camp.status == 'joined' || this.props.camp.status == 'admin');

		return (

			<div className="">

				{ !this.props.feed.fetching.posts && hasCampAccess && <Submit dispatch={this.props.dispatch} camp={isCamp ? this.props.camp : {}} fetching={this.props.feed.fetching.newPosts} /> }

				{ !!this.props.feed.newPosts && this.props.feed.newPosts.length > 0 && 
					<div className="ptop10 pbot10 mbot20 bg-light-success bg-slightly-transparent text-white text-center clickable" onClick={this.addNewPosts}>
						<p>New posts!</p>
					</div>
				}

				<div className="mbot20" id="feedList">
					{ !!this.props.feed.fetching.posts && !this.props.feed.posts.length
	            		? <FeedLoader />
						: posts.length > 0
							? posts.map( post => {
								return <Element name={post.uniqueID} key={'feed-post-'+post.uniqueID}>
									<div className="mbot20 feed-item">
										{ ( () => {
											switch (post.post_type.singular_lower) {
												case "question": 	return <Question {...post} dispatch={this.props.dispatch} />
												case "article": 	return <Article {...post} dispatch={this.props.dispatch} />
												case "statement": 	return <Statement {...post} dispatch={this.props.dispatch} selectPost={this.selectPost} />
											}
										} )() }
										<div className="clearfix"></div>
									</div>
								</Element>
							})	
							: <p className="text-center mbot0 ptop20 pbot20">{isCamp ? 'Be the first to post' : 'You have no posts yet. Add some interests or join some camps.'}</p>
					}
					<div className="clearfix"></div>
				</div>

			</div>

		)

	},

    componentWillUnmount: function(){
        this.clearInterval();
    }

})

const mapStateToProps = state => ({
    feed: state.feed,
});

const mapDispatchToProps = dispatch => bindActionCreators({ emptyNewPosts, getNewCampFeed, getNewMainFeed }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( Feed );




// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/DashboardFeed-Main.jsx